// AI proposal location strip: physical shooting locations in shooting order, derived from the
// day's entries. Scenes supply their screenplay/Breakdown location; the day's saved physical
// locations (by stable identity and scene association) or the manager's draft corrections replace the screenplay name. Company
// Move activities between blocks become separators. Display/draft only until approval.
const key = s => String(s || '').trim().toUpperCase();

export function locationBlocks(entries = [], sceneByUid = new Map(), dayLocations = [], overrides = {}) {
  const items = []; let pendingMove = null; let block = null;
  for (const e of entries) {
    if (e.kind === 'activity' && e.activityType === 'COMPANY_MOVE') { pendingMove = (pendingMove || 0) + (e.durationMin || 0); continue; }
    if (e.kind !== 'scene') continue;
    const scene = sceneByUid.get(e.sceneUid);
    const source = scene?.location || String(scene?.heading || e.name || '').replace(/\s+-\s+[^-]*$/, '') || 'Unknown location';
    if (block && pendingMove===null && key(block.source) === key(source)) { block.scenes.push(e.sceneUid); pendingMove = null; continue; }
    if (block) items.push({ type: 'move', minutes: pendingMove });
    pendingMove = null;
    block = { type: 'location', blockId:e.id || e.sceneUid, source, scenes: [e.sceneUid] };
    items.push(block);
  }
  for (const it of items) if (it.type === 'location') {
    const o = overrides[it.blockId] || overrides[key(it.source)]; const candidates=dayLocations.filter(l=>(l.sceneUids||[]).some(uid=>it.scenes.includes(uid))); const saved=candidates.length===1?candidates[0]:null;
    const place = o || (saved?.name ? saved : null);
    it.id=place?.id;it.locationId=place?.locationId;it.locationRevision=place?.locationRevision; it.hospital=place?.hospital; it.sceneUids=it.scenes;
    it.name = place?.name || it.source; it.address = place?.address || ''; it.confirmed = Boolean(o); it.fromSchedule = !o && Boolean(place);
  }
  return items;
}

// Locations saved on approval: distinct physical places in shooting order.
export const confirmedLocations = blocks => {
  const out=[];
  for(const b of blocks) if(b.type==='location') {
    const existing=b.id?out.find(l=>l.id===b.id):null;
    if(existing) existing.sceneUids=[...new Set([...existing.sceneUids,...b.scenes])];
    else out.push({...(b.id?{id:b.id}:{}),sceneUids:[...new Set(b.scenes)],...(b.locationId?{locationId:b.locationId,locationRevision:b.locationRevision}:{}),...(b.hospital?{hospital:b.hospital}:{}),name:b.name.slice(0,200),address:(b.address||'').slice(0,400)});
  }
  return out;
};

export const overrideKey = key;
